"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRolesApiClient = createRolesApiClient;
const axios_client_1 = require("@invivodf/axios-client");
const errors_1 = require("../infra/errors");
/**
 * Créer un client API pour la gestion des rôles
 * @param apiHost L'URL de base de l'API
 * @param options Options du client Axios (authentification, headers, etc.)
 * @returns Un client API pour les opérations sur les rôles
 */
function createRolesApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function createRole(request) {
        try {
            const response = await client.post('/v1/roles', request);
            return response.data;
        }
        catch (err) {
            (0, errors_1.handleError)(err);
        }
    }
    return {
        createRole
    };
}
